module.exports = __webpack_public_path__ + "static/media/Group8948.557bde42.png";